import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => ({
  flexRow: {
    display: 'flex',
    flexDirection: 'row'
  },
  container: {
    backgroundColor: theme.palette.common.white,
    margin: '0 0 24px 0',
    borderRadius: 18,
    border: '1px solid rgba(16,24,40,0.07)',
    boxShadow:
      'inset 0 1px 0 rgba(255,255,255,0.9), 0 1px 2px rgba(16,24,40,0.06), 0 10px 28px -12px rgba(16,24,40,0.18)',
    backgroundImage: 'linear-gradient(180deg, #FFFFFF 0%, #FBFBFC 100%)',
    textAlign: 'left',
    overflow: 'hidden',
    paddingBottom: 0
  },
  heading: {
    backgroundColor: theme.palette.common.white,
    backgroundImage:
      'linear-gradient(180deg, rgba(255,241,233,0.75) 0%, rgba(255,255,255,0) 100%)',
    width: '100%',
    padding: '24px 24px 8px 24px',
    textAlign: 'left'
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    columnGap: 16,
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr'
    }
  },
  section: {
    marginTop: 28,
    paddingTop: 20,
    borderTop: `1px solid ${theme.palette.divider}`
  },
  headingBlack: {
    backgroundColor: theme.palette.common.white,
    backgroundImage:
      'linear-gradient(180deg, rgba(255,241,233,0.75) 0%, rgba(255,255,255,0) 100%)',
    width: '100%',
    padding: '16px 24px',
    borderBottom: `1px solid ${theme.palette.divider}`,
    borderRadius: '16px 16px 0 0',
    textAlign: 'left'
  },
  text: {
    color: theme.palette.text.primary,
    fontSize: 16,
    fontWeight: 700
  },
  textWhite: {
    color: theme.palette.text.primary,
    fontSize: 16,
    fontWeight: 700
  },
  form: {
    margin: '4px 24px 24px 24px',
    alignItems: 'stretch',
    textAlign: 'left'
  },
  labelText: {
    textAlign: 'left',
    marginLeft: 0,
    fontSize: '13px',
    fontWeight: 600,
    color: theme.palette.text.primary,
    marginTop: '16px'
  },
  customNotification: {
    borderRadius: '8px', // Use camelCase
    boxShadow: 'none' // Use camelCase
  }
}))

export default useStyles
